var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVegetables10 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "673.661px",
    height: "695.575px",
    viewBox: "0 0 673.661 695.575",
    enableBackground: "new 0 0 673.661 695.575",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M489.795,321.646l-37.621,373.928H234.891L197.27,363.294l158.907-26.972 l-0.841-14.676H0C6.397,142.949,154.727,0,336.843,0c182.092,0,330.446,142.949,336.818,321.646H489.795L489.795,321.646z  M109.027,265.9l97.586,2.975c-1.113-32.137-3.477-77.181,3.916-117.287l-56.895-20.974 C125.709,166.943,110.875,218.858,109.027,265.9L109.027,265.9z M216.717,126.798c5.414-16.582,13.24-31.463,24.449-42.974 c-27.089,0.162-50.016,10.31-68.736,26.66L216.717,126.798z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVegetables10, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vegetables-10.10cfa5fb.svg";
export { ForwardRef as ReactComponent };